import { getAllProvinces } from '@/services/api-transit/administrativeUnits';
import { useState } from 'react';

export default () => {
  const [data, setData] = useState<API.AdministrativeUnitProvinceV2[] | null>(null);
  const [valueEnum, setValueEnum] = useState<Record<string, string> | null>(null);
  const [valueOptions, setValueOptions] = useState<{ value: string; label: string }[]>([]);

  const fetch = async () => {
    const res = await getAllProvinces();
    setData(res);
    setValueEnum(
      res?.reduce(
        (pre: Record<string, string>, curr: API.AdministrativeUnitProvinceV2) => ({
          ...pre,
          [curr.id.toString()]: curr.name,
        }),
        {},
      ),
    );
    setValueOptions(
      res?.map((item: API.AdministrativeUnitProvinceV2) => ({
        value: item.province_code,
        label: item.name,
      })),
    );
  };

  const reset = () => {
    setData(null);
    setValueEnum(null);
    setValueOptions([]);
  };

  return {
    fetch,
    reset,
    data,
    valueEnum,
    valueOptions,
  };
};
